import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import Blog from "../Items/Blog";

function Blogs({ repos = [] }) {
  const formattedRepos = () =>
    repos.map((item) => ({
      title: item.full_name.replace("lucasspi/", "").replace("---", " | ").replaceAll("-", " "),
      date: moment(item.created_at).format("MMM, YYYY"),
      author: "Lucas S",
      slug: item.clone_url,
      topics: item.topics,
    })) || [];

  return (
    <>
      <div className="row mb-3">
        {formattedRepos().map((blog) => (
          <div className="col-md-4 mb-4" key={blog.id}>
            <Blog blog={blog} />
          </div>
        ))}
      </div>
      <div className="spacer" data-height="50"></div>
      <div className="text-center">
        <Link
          to={{ pathname: "https://github.com/lucasspi" }}
          target="_blank"
          className="btn btn-default"
        >
          Show All
        </Link>
      </div>
    </>
  );
}

export default Blogs;
